import apiService from './api';
import type { ApiResponse } from '../types';

export type SprayTncAudience = 'creator' | 'operator' | 'all';

export interface SprayTncCurrent {
  id: number | null;
  version: string | null;
  title: string | null;
  content: string | null;
  audience: SprayTncAudience;
  effective_from: string | null;
  hasAccepted: boolean;
}

export interface SprayTncVersion {
  id: number;
  version: string;
  title: string;
  audience: SprayTncAudience;
  effective_from: string;
  is_active: boolean;
  created_at: string;
  created_by: number | null;
  created_by_username: string | null;
  acceptance_count: number;
}

export interface SprayTncVersionFull extends SprayTncVersion {
  content: string;
}

export interface SprayTncAcceptanceRow {
  id: number;
  user_id: number;
  organisation_id: number;
  accepted_at: string;
  ip_address: string | null;
  user_agent: string | null;
  username: string;
  first_name: string | null;
  last_name: string | null;
  organisation_name: string;
}

export async function getCurrentTnc(): Promise<ApiResponse<SprayTncCurrent>> {
  return apiService.get<SprayTncCurrent>('/spray/tnc/current');
}

export async function acceptTnc(versionId: number): Promise<ApiResponse<unknown>> {
  return apiService.post<unknown>('/spray/tnc/accept', { version_id: versionId });
}

export async function listTncVersions(): Promise<ApiResponse<SprayTncVersion[]>> {
  return apiService.get<SprayTncVersion[]>('/spray/tnc/versions');
}

export async function getTncVersion(id: number): Promise<ApiResponse<SprayTncVersionFull>> {
  return apiService.get<SprayTncVersionFull>(`/spray/tnc/versions/${id}`);
}

export async function createTncVersion(data: {
  version: string;
  title: string;
  content: string;
  audience: SprayTncAudience;
}): Promise<ApiResponse<SprayTncVersionFull>> {
  return apiService.post<SprayTncVersionFull>('/spray/tnc/versions', data);
}

export async function listTncAcceptances(versionId: number): Promise<ApiResponse<SprayTncAcceptanceRow[]>> {
  return apiService.get<SprayTncAcceptanceRow[]>(`/spray/tnc/versions/${versionId}/acceptances`);
}
